module.exports = __webpack_public_path__ + "img/cast_home_banner.5464fb78.svg";